import { InjectionToken } from '@angular/core';

import type { AuthConfig } from './auth.models';

export const BECKS_AUTH_CONFIG = new InjectionToken<AuthConfig>('becks.okta.config.angular');
